import { render, staticRenderFns } from "./zhuyaozhengzhuangmingchen.vue?vue&type=template&id=71c643b2&"
import script from "./zhuyaozhengzhuangmingchen.vue?vue&type=script&lang=ts&"
export * from "./zhuyaozhengzhuangmingchen.vue?vue&type=script&lang=ts&"
import style0 from "./zhuyaozhengzhuangmingchen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports